<template>
  <div data-view="index">This is the index page</div>
</template>
